export default "/images/vendor/flag-icon-css/flags/1x1/vg.svg?2ee2d8bebdf1602ce3a1fda0ced156a3";